import { useState } from 'react';

export const usePrevProp = (state, areEqual = Object.is) => {
  const [prevState, setPrevState] = useState(state);
  const hasChanged = !areEqual(prevState, state);
  if (hasChanged) {
    setPrevState(state);
  }

  return [prevState, hasChanged];
};
